import {
  ArrowLeftRight as ArrowsRightLeftIcon,
  Beaker as BeakerIcon,
  BookOpen as BookOpenIcon,
  Building2 as BuildingIcon,
  ChartBar as ChartBarIcon,
  Monitor as ComputerDesktopIcon,
  FileSearch as DocumentMagnifyingGlassIcon,
  FileLock2 as FileLockIcon,
  Flag as FlagIcon,
  House as HomeIcon,
  Map as MapIcon,
  Megaphone as MegaphoneIcon,
  MessageCircle as MessageCircleIcon,
  Ban as NoSymbolIcon,
  Settings as SettingsIcon,
  ShieldAlert as ShieldAlertIcon,
  ShieldCheck as ShieldCheckIcon,
  Grid2X2 as Squares2X2Icon,
  ThumbsUp as ThumbsUpIcon,
  User as UserIcon,
} from 'lucide-react';
import { MenuItem } from './MenuItem.interface';

export const menuItems: MenuItem[] = [
  {
    path: 'analytics',
    title: 'Analytics',
    icon: <ChartBarIcon className="h-6 w-6" />,
    viewPermission: 'analytics.view',
  },
  {
    path: 'ask-chiroup',
    title: 'Ask ChiroUp',
    icon: <MessageCircleIcon className="h-6 w-6" />,
    viewPermission: 'ask_chiroup.use',
  },
  {
    path: 'clinic-map',
    title: 'Clinics Map',
    icon: <MapIcon className="h-6 w-6" />,
    viewPermission: 'clinic_map.view',
  },
  {
    path: 'users',
    title: 'Users',
    icon: <UserIcon className="h-6 w-6" />,
    viewPermission: 'users.view',
  },
  {
    path: 'clinics',
    title: 'Clinics',
    icon: <BuildingIcon className="h-6 w-6" />,
    viewPermission: 'clinic.view',
  },
  {
    path: 'referrals',
    title: 'Referrals',
    icon: <MegaphoneIcon className="h-6 w-6" />,
    viewPermission: 'referrals.view',
  },
  {
    path: 'secure-cases',
    title: 'Secure Cases',
    icon: <FileLockIcon className="h-6 w-6" />,
    viewPermission: 'secure_cases.view',
  },
  {
    path: 'research',
    title: 'Research',
    icon: <DocumentMagnifyingGlassIcon className="h-6 w-6" />,
    viewPermission: 'research.view',
    menuItems: [
      {
        path: '',
        title: 'Manage articles',
        viewPermission: 'research.view',
      },
      {
        path: 'analytics',
        title: 'Review analytics',
        viewPermission: 'research.analytics',
      },
    ],
  },
  {
    path: 'disabilities',
    title: 'Disabilities',
    viewPermission: 'disabilities.view',
    icon: <ShieldAlertIcon className="h-6 w-6" />,
  },
  {
    path: 'tests',
    title: 'Tests',
    icon: <BeakerIcon className="h-6 w-6" />,
    viewPermission: 'tests.view',
  },
  {
    path: 'home-page',
    title: 'Home Page',
    icon: <HomeIcon className="h-6 w-6" />,
    viewPermission: 'home_page.view',
    menuItems: [
      {
        path: '/home-page-v2',
        title: 'New Builder',
        absolutePath: true,
        badge: { label: 'NEW', tone: 'new' },
        viewPermission: 'home_page.view',
      },
      {
        path: '/home-page',
        title: 'Original',
        absolutePath: true,
        badge: { label: 'LEGACY', tone: 'legacy' },
        viewPermission: 'home_page.view',
      },
      {
        path: 'trial-experience',
        title: 'Trial Experience',
      },
    ],
  },
  {
    path: 'login-content',
    title: 'Login Screen',
    icon: <ComputerDesktopIcon className="h-6 w-6" />,
    viewPermission: 'login_screen.view',
  },
  {
    path: 'new-user-dashboard',
    title: 'New user dashboard',
    icon: <Squares2X2Icon className="h-6 w-6" />,
    viewPermission: 'new_user_dashboard.view',
  },
  {
    path: 'student-verification',
    title: 'Student verification',
    icon: <UserIcon className="h-6 w-6" />,
    viewPermission: 'student_verification.view',
  },
  {
    path: 'admin-users',
    title: 'Admin Users',
    icon: <ShieldCheckIcon className="h-6 w-6" />,
    viewPermission: 'admin_users.view',
  },
  {
    path: 'device-blocklist',
    title: 'Device Blocklist',
    icon: <NoSymbolIcon className="h-6 w-6" />,
    viewPermission: 'device_blocklist.view',
  },
  {
    path: 'flags',
    title: 'Feature flags',
    icon: <FlagIcon className="h-6 w-6" />,
    viewPermission: 'flags.view',
  },
  {
    path: 'marketing',
    title: 'Marketing',
    viewPermission: 'marketing.view',
    icon: <ThumbsUpIcon className="h-6 w-6" />,
  },
  {
    path: 'clinical-skills',
    title: 'Clinical skills',
    viewPermission: 'clinical_skills.view',
    icon: <BookOpenIcon className="h-6 w-6" />,
    menuItems: [
      {
        path: 'conditions',
        title: 'Condition reference',
      },
      {
        path: 'evaluations',
        title: 'Clinical evaluations',
      },
      {
        path: 'treatments',
        title: 'Treatment techniques',
      },
      {
        path: 'exercises',
        title: 'Exercises',
      },
      {
        path: 'modality',
        title: 'Modalities',
      },
      {
        path: 'advice',
        title: 'Advice',
      },
      {
        path: 'supplements',
        title: 'Supplements and Supplies',
      },
      {
        path: 'common-treatments',
        title: 'My treatment desc.',
      },
    ],
  },
  {
    path: 'practice-resources',
    title: 'Practice resources',
    icon: <BuildingIcon className="h-6 w-6" />,
    viewPermission: 'practice_resources.view',
    menuItems: [
      {
        path: 'marketing-campaigns',
        title: 'Marketing campaigns',
        viewPermission: 'practice_resources.view',
      },
      {
        path: 'forms-library/business',
        title: 'Forms library',
        viewPermission: 'practice_resources.view',
      },
    ],
  },
  {
    // Deliberately its OWN section (not devtools): the audience is mixed —
    // key rotation is tech_admin work today, and the inbound Queues page
    // (Unrouted / Unsupported / Resolved) is billing-support work;
    // devtools.* permissions exclude support. "Unrouted" is the epoch
    // vocabulary — NOT "unmatched", which is the claim-level concept. A
    // support-inclusive permission may later join viewAnyOf + the sub-item.
    path: 'connection-api',
    title: 'Connection API',
    icon: <ArrowsRightLeftIcon className="h-6 w-6" />,
    viewAnyOf: ['platform.manage_connector_credentials'],
    menuItems: [
      {
        path: '',
        title: 'Console',
        viewPermission: 'platform.manage_connector_credentials',
      },
      {
        path: 'operations',
        title: 'Operations',
        viewPermission: 'platform.manage_connector_credentials',
      },
      {
        path: 'queues',
        title: 'Queues',
        viewPermission: 'platform.manage_connector_credentials',
      },
    ],
  },
  {
    path: 'developer-tools',
    title: 'Developer tools',
    icon: <SettingsIcon className="h-6 w-6" />,
    viewAnyOf: [
      'devtools.transaction_debug',
      'devtools.invoices',
      'devtools.eras',
      'devtools.dejavoo_diagnostics',
    ],
    menuItems: [
      {
        path: 'transaction-debug',
        title: 'Transaction debug',
        viewPermission: 'devtools.transaction_debug',
      },
      {
        path: 'invoice-panel',
        title: 'Invoices',
        viewPermission: 'devtools.invoices',
      },
      {
        path: 'crossover-repair',
        title: 'Crossover claim repair',
        viewPermission: 'devtools.invoices',
      },
      {
        path: 'era-panel',
        title: 'ERAs',
        viewPermission: 'devtools.eras',
      },
      {
        path: 'patient-panel',
        title: 'Patients',
        viewPermission: 'devtools.transaction_debug',
      },
      {
        path: 'dejavoo-diagnostics',
        title: 'Dejavoo diagnostics',
        viewPermission: 'devtools.dejavoo_diagnostics',
      },
    ],
  },
  // {
  //   path: 'whats-new',
  //   title: "What's new",
  //   icon: (
  //     <svg
  //       xmlns="http://www.w3.org/2000/svg"
  //       className="h-6 w-6"
  //       fill="none"
  //       viewBox="0 0 24 24"
  //       stroke="currentColor"
  //       strokeWidth={2}
  //     >
  //       <path
  //         strokeLinecap="round"
  //         strokeLinejoin="round"
  //         d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z"
  //       />
  //     </svg>
  //   ),
  // },
];
